import { render, staticRenderFns } from "./achievementMarket.vue?vue&type=template&id=981e16aa&scoped=true"
import script from "./achievementMarket.vue?vue&type=script&lang=js"
export * from "./achievementMarket.vue?vue&type=script&lang=js"
import style0 from "./achievementMarket.vue?vue&type=style&index=0&id=981e16aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981e16aa",
  null
  
)

export default component.exports